/**
 * AW RM — primary nav burger toggle.
 *
 * The header now renders a classic wp_nav_menu (see inc/primary-nav.php),
 * so WordPress provides `current-menu-item` and per-item CSS classes
 * automatically. The only nav JS still needed is the mobile burger toggle:
 * flipping `aria-expanded` on the button and `is-open` on the wrapper to
 * reveal the overlay menu under 992px.
 */

( function () {
	'use strict';

	function ready( fn ) {
		if ( document.readyState !== 'loading' ) {
			fn();
		} else {
			document.addEventListener( 'DOMContentLoaded', fn );
		}
	}

	ready( function () {
		var toggles = document.querySelectorAll( '.aw-rm-main-nav-toggle' );
		toggles.forEach( function ( btn ) {
			var wrap = btn.nextElementSibling;
			if ( ! wrap || ! wrap.classList.contains( 'aw-rm-main-nav-wrap' ) ) {
				return;
			}
			btn.addEventListener( 'click', function () {
				var expanded = btn.getAttribute( 'aria-expanded' ) === 'true';
				btn.setAttribute( 'aria-expanded', expanded ? 'false' : 'true' );
				wrap.classList.toggle( 'is-open', ! expanded );
			} );

			// Close the menu when an item is clicked (so single-page nav feels
			// snappy on mobile).
			wrap.querySelectorAll( '.menu-item a' ).forEach( function ( a ) {
				a.addEventListener( 'click', function () {
					btn.setAttribute( 'aria-expanded', 'false' );
					wrap.classList.remove( 'is-open' );
				} );
			} );
		} );
	} );
}() );
